// Building type constants
// Note: These should match BUILDING_TYPES in backend/api/constants/addresses.js
export const BUILDING_TYPES = {
  APARTMENT: 'דירה',
  VILLA: 'וילה',
  COTTAGE: 'קוטג\'',
  OTHER: 'אחר'
};

// Array of all building type values (for validation/enum)
export const BUILDING_TYPE_VALUES = Object.values(BUILDING_TYPES);

// Building type options for select dropdown
export const BUILDING_TYPE_OPTIONS = [
  { value: BUILDING_TYPES.APARTMENT, label: 'דירה' },
  { value: BUILDING_TYPES.VILLA, label: 'וילה' },
  { value: BUILDING_TYPES.COTTAGE, label: 'קוטג\'' },
  { value: BUILDING_TYPES.OTHER, label: 'אחר' }
];

// Access path option constants
// Note: These should match ACCESS_PATH_OPTIONS in backend/api/constants/addresses.js
export const ACCESS_PATH_OPTIONS = {
  HAS_TRUCK_PARKING: 'יש מקום חניה למשאית',
  CLOSE: 'קרוב',
  HAS_STAIRS: 'כולל מדרגות'
};

// Array of all access path option values (for validation/enum)
export const ACCESS_PATH_VALUES = Object.values(ACCESS_PATH_OPTIONS);

// Access path options for checkboxes
export const ACCESS_PATH_OPTIONS_ARRAY = [
  { value: ACCESS_PATH_OPTIONS.HAS_TRUCK_PARKING, label: 'יש מקום חניה למשאית' },
  { value: ACCESS_PATH_OPTIONS.CLOSE, label: 'קרוב' },
  { value: ACCESS_PATH_OPTIONS.HAS_STAIRS, label: 'כולל מדרגות' }
];

